import { useNotify } from "@utils";
import { Col, Divider, Row, Skeleton, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import {
    IGetWebsaleTopSpenderExample
} from "src/Interfaces/topCharoen";
import styled from "styled-components";
import { KeyIcon } from "../icon/EventActivity/KeyIcon";
import { ScanIcon } from "../icon/EventActivity/Scan";
import topImage from "../icon/EventActivity/top.png";
import { BackWhiteIcon } from "../icon/TopSpender/BackWhiteIcon";
const { TabPane } = Tabs;
interface IProps {
    userInfo: any;
    loggedInUser?: IGetWebsaleTopSpenderExample;
}

export const EventProgress = (props: IProps) => {
    const { success, error } = useNotify();
    const { userInfo, loggedInUser } = props;
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const [eventActivity, setEventActivity] = useState<boolean>(true);
    const [tab, setTab] = useState<string>("1");

    const initialContent =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.";

    const [showAll, setShowAll] = useState(false);
    const lastCharacterIndex = 100;
    const displayContent = showAll ? initialContent : initialContent.substring(0, 100); // เปลี่ยนตัวเลขตามที่คุณต้องการ

    const handleReadMoreClick = () => {
        setShowAll(!showAll);
    };
    const lastCharacter = initialContent.charAt(lastCharacterIndex);
    const indexOfLastCharacter = displayContent.lastIndexOf(lastCharacter);

    // const getList = async () => {
    //     try {
    //         const get = await topCharoenAPI.getWebsaleTopSpenders({
    //             organization_id: userInfo.merchantId,
    //             xpage: 1,
    //             xlimit: 100,
    //             sale_date_from: "2023-01-15",
    //             sale_date_to: "2023-10-15",
    //             is_member_only: false,
    //         });
    //         if (get.data.error === "0") {
    //             setUserList(get.data.result);
    //         } else {
    //             error(get.data.msg);
    //         }
    //     } catch (err: any) {
    //         error(err.message);
    //     }
    // };

    function callback(items: any) {
        setTab(items);
    }

    useEffect(() => {
        // getList();
    }, []);

    return eventActivity ? (
        <StyledContainer color={"#336C51"}>
            <div className="container">
                <div className="backIcon" onClick={() => history.push("/")}>
                    <BackWhiteIcon />
                </div>
                <div className="topImage">
                    <img src={topImage} alt="test" className="topHeaderImage" />
                </div>
                <div className="content">
                    <Tabs
                        defaultActiveKey="1"
                        activeKey={tab}
                        onChange={callback}
                        tabBarStyle={{
                            backgroundColor: "transparent",
                        }}
                    >
                        <TabPane tab={"Information"} key="1">
                            <div>
                                <h1>Songkran Event</h1>
                                <p>
                                    {displayContent}
                                    <span>
                                        {initialContent.length > 100 && (
                                            <button
                                                onClick={handleReadMoreClick}
                                                className="read-more-button"
                                            >
                                                {showAll ? "Read Less" : "Read More"}
                                            </button>
                                        )}
                                    </span>
                                </p>
                                <Divider />
                                <div className="listColumn">
                                    <Row className={`listItemsReward`} key={1}>
                                        <Col
                                            span={6}
                                            style={{
                                                paddingLeft: 0,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: "relative",
                                                    width: "24px",
                                                }}
                                            >
                                                {/* <MedalIcon /> */}
                                                <img
                                                    src={topImage}
                                                    alt="medal"
                                                    style={{
                                                        width: "42px",
                                                        height: "42px",
                                                        borderRadius: "8px",
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <p className="gray">
                                                <span>
                                                    <KeyIcon />
                                                </span>
                                                Unlock per 10 QR Code
                                            </p>
                                            <p>Get Reward....</p>
                                        </Col>
                                        <Col span={6}>
                                            <p></p>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab={"My Collect QR Code"} key="2">
                            <div>gg</div>
                        </TabPane>
                    </Tabs>
                    <div className="bottomContent">
                        <button>
                            <ScanIcon />
                            Scan collect now!
                        </button>
                    </div>
                </div>
            </div>
        </StyledContainer>
    ) : (
        <Skeleton />
    );
};
const StyledContainer = styled.div<{ color: string }>`
    height: 100dvh;
    .container {
        .backIcon {
            position: absolute;
            top: 20px;
            left: 20px;
            cursor: pointer;
            z-index: 1;
        }
        background: linear-gradient(
                180deg,
                rgba(255, 255, 255, 255) 45%,
                ${(props) => props.color} 100%
            ),
            linear-gradient(
                180deg,
                rgba(195, 155, 108, 0) 0%,
                rgba(195, 155, 108, 0.42) 70.31%,
                #fff 100%
            ),
            #fff;
        // min-height: 100vh;
        .ant-divider {
            background: #e1e1e1;
            width: 90%;
            min-width: 90%;
            margin: auto;
            margin: 22px auto 16px auto;
        }
    }
    .topHeaderImage {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .topImage {
        position: relative;
        min-height: 200px;
        /* padding-bottom: 10px; */
    }
    .whiteGradiant {
        background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.62) 90%,
            #fff 100%
        );
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        z-index: 0;
    }
    .content {
        width: 100%;
        height: 65dvh;
        background-color: rgba(246, 246, 246, 1);
        position: absolute;
        left: 0;
        bottom: 0;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        overflow: hidden;
        padding: 9px 16px 0px 16px;
        h1 {
            color: #000;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        p {
            color: #9b9b9b;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
        }
        small {
            color: #525257;
            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            display: block;
        }
        .read-more-button {
            text-decoration: underline;
            background: none;
            border: none;
            cursor: pointer;
            color: #336c51;
            font-size: inherit;
        }
        .listColumn {
            display: flex;
            flex-direction: column;
            gap: 6px;
            position: relative;
            overflow: auto;
            height: 62vh;
            padding-bottom: 20px;
            th {
                color: #9b9b9b;
                font-family: Inter;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
            }
            .ant-row {
                padding: 6px 18px;
            }
            .listItemsRow {
                padding: 12px 20px;
                border-radius: 12px;
                background: #fff;
                display: flex;
                place-items: center;
                box-shadow: none;
                p {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    text-align: left;
                    margin: 0;
                }
                .gray {
                    color: #9b9b9b;
                    font-size: 12px;
                }
                .blueText {
                    color: ${(p) => p.color};
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: inherit;
                    text-align: right;
                }
                .placeIndex {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    padding-left: 8px;
                }
                .textrank : {
                    color: #fff;
                    font-size: 8px;
                }
            }
            .listItemsReward {
                padding: 12px 20px;
                border-radius: 12px;
                background: rgba(51, 108, 81, 0.08);
                display: flex;
                place-items: center;
                box-shadow: none;
                p {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    text-align: left;
                    margin: 0;
                }
                .gray {
                    color: #9b9b9b;
                    font-size: 12px;
                }
                .placeIndex {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    padding-left: 8px;
                }
            }
        }
        .bottomContent {
            display: flex;
            padding: 16px 16px 12px 16px;
            flex-direction: column;
            align-items: center;
            gap: 9px;
            align-self: stretch;
            width: 100%;
            height: 10dvh;
            background: linear-gradient(
                    180deg,
                    rgba(196, 163, 99, 0.32) 0%,
                    rgba(196, 163, 99, 0) 92.98%
                ),
                #fff;
            position: absolute;
            left: 0;
            bottom: 0;
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            button {
                display: flex;
                padding: 14.5px 24px;
                justify-content: center;
                align-items: center;
                gap: 4px;
                align-self: stretch;
                border-radius: 14px;
                border: 1px solid var(--Hightlight, #f2ca3c);
                background: var(--Primary-1, #336c51);
                box-shadow: 0px 4px 12px 0px rgba(242, 202, 60, 0.32);
                color: var(--Text-6, #fff);
                text-align: center;
                font-family: Inter;
                font-size: 13px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
        }

        textScan {
            color: var(--Text-6, #fff);
            text-align: center;
            font-family: Inter;
            font-size: 13px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        .bottomContentAndRank {
            display: flex;
            padding: 16px 16px 12px 16px;
            flex-direction: column;
            align-items: center;
            gap: 9px;
            align-self: stretch;
            width: 100%;
            height: 15dvh;
            background: linear-gradient(
                    180deg,
                    rgba(196, 163, 99, 0.32) 0%,
                    rgba(196, 163, 99, 0) 92.98%
                ),
                #fff;
            position: absolute;
            left: 0;
            bottom: 0;
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            button {
                display: flex;
                padding: 14.5px 24px;
                justify-content: center;
                align-items: center;
                gap: 4px;
                align-self: stretch;
                border-radius: 14px;
                border: 1px solid var(--Hightlight, #f2ca3c);
                background: var(--Primary-1, #336c51);
                box-shadow: 0px 4px 12px 0px rgba(242, 202, 60, 0.32);
                color: var(--Text-6, #fff);
                text-align: center;
                font-family: Inter;
                font-size: 13px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .listItemsRow {
                padding: 0px 20px;
                width: 100%;
                display: flex;
                place-items: center;
                box-shadow: none;
                p {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    text-align: left;
                    margin: 0;
                }
                .gray {
                    color: #9b9b9b;
                    font-size: 12px;
                }
                .blueText {
                    color: ${(p) => p.color};
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: inherit;
                    text-align: right;
                }
                .placeIndex {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    padding-left: 8px;
                }
                .textrank : {
                    color: #fff;
                    font-size: 8px;
                }
            }
        }
    }
    
`;
